import { Box, Menu, Toolbar, Typography } from '@mui/material';

import { CommonlandsLogo } from 'components/Icons';
import FilterButton from 'components/FilterButton';
import MenuIcon from '@mui/icons-material/Menu';
import React from 'react';
import { useMainContext } from 'pages/PublicPage/Layout';
import VerifyGroupBtn from './VerifyGroupBtn';

const MENU = [
  { label: 'About Commonlands', url: 'https://www.commonlands.org/' },
  { label: 'Help Center', url: 'https://commonlands.zendesk.com' },
];
const Items = ({ sx }) => {
  return MENU.map((i) => {
    return (
      <Typography
        key={i.label}
        variant="h6"
        noWrap
        sx={{
          color: 'white',
          fontSize: '16px',
          fontWeight: 'bold',
          textDecoration: 'none',
          cursor: 'pointer',
          ...sx,
        }}
        component="a"
        href={i.url}
        target="_blank"
      >
        {i.label}
      </Typography>
    );
  });
};
const MenuItem = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box
      sx={{
        display: { xs: 'flex', lg: 'none' },
      }}
    >
      <MenuIcon
        sx={{ mr: '4px', color: 'white', cursor: 'pointer' }}
        onClick={handleClick}
      />
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            px: '12px',
            gap: '4px',
          }}
        >
          <Items
            sx={{
              color: 'black',
              fontSize: '12px !important',
            }}
          />
        </Box>
      </Menu>
    </Box>
  );
};

export default function Index() {
  const { onOpenVerify, setCertVerify } = useMainContext();

  return (
    <Box
      sx={{
        height: '60px',
        background: 'linear-gradient(270deg, #5FC4AC 0%, #3477BD 100%)',
        boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
      }}
    >
      <Box
        position="static"
        sx={{
          height: '100%',
        }}
      >
        <Toolbar
          sx={{
            height: '100%',
            gap: '12px',
          }}
        >
          <CommonlandsLogo
            sx={{
              width: '30px',
              color: 'white',
            }}
          />
          <MenuItem />
          <Box
            sx={{
              gap: '12px',
              ml: '12px',
              display: { xs: 'none', lg: 'flex' },
            }}
          >
            <Items />
          </Box>

          <FilterButton />
          <VerifyGroupBtn
            setCertVerify={setCertVerify}
            onOpenVerify={onOpenVerify}
          />
        </Toolbar>
      </Box>
    </Box>
  );
}
